import { render, staticRenderFns } from "./Residential.vue?vue&type=template&id=c3ca2604&"
import script from "./Residential.vue?vue&type=script&lang=js&"
export * from "./Residential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports